import React from "react";
import "./ProjectVideos.css";

function ProjectVideos() {
  return (
    <div className="project-videos">
      <h2 className="section-title">Project Videos</h2>

      <div className="video-gallery">
        {/* FB Wynwood */}
        <div className="video-card">
          <h3 className="video-title">FB Wynwood</h3>
          <video
            controls
            className="video-player"
            src="/Videos/FB_Wynwood.mp4"
            type="video/mp4"
          >
            Your browser does not support the video tag.
          </video>
        </div>

        {/* Tower 350 */}
        <div className="video-card">
          <h3 className="video-title">Tower 350</h3>
          <video
            controls
            className="video-player"
            src="/Videos/Tower350.mp4"
            type="video/mp4"
          >
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="video-card">
          <h3 className="video-title">Villa Vizcaya</h3>
          <video
            controls
            className="video-player"
            src="/Videos/Villa_Vizcaya.mp4"
            type="video/mp4"
          >
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="video-card">
          <h3 className="video-title">Vantage Apartments</h3>
          <video
            controls
            className="video-player"
            src="/Videos/Vantage_Apt.mp4"
            type="video/mp4"
          >
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  );
}

export default ProjectVideos;
